<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="page-title">
                    <h2>{{'sidebar.change_password' | translate}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">{{'user_profile.change_password_form' | translate}}</h4>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
                            <div class="mb-3">
                                <label class="form-label">{{'user_profile.old_password' | translate}}</label>
                                <input type="password" formControlName="oldPassword" class="form-control" />
                                <div *ngIf="f.oldPassword.touched && f.oldPassword.invalid" class="text-danger small mt-1">
                                    {{'user_profile.old_password_required' | translate}}
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">{{'user_profile.new_password' | translate}}</label>
                                <input type="password" formControlName="newPassword" class="form-control" />
                                <div *ngIf="f.newPassword.touched && f.newPassword.invalid" class="text-danger small mt-1">
                                    <span *ngIf="f.newPassword.errors.required">{{'user_profile.new_password_required' | translate}}</span>
                                    <span *ngIf="f.newPassword.errors.minlength">{{'user_profile.new_password_must_be_valid' | translate}}</span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">{{'signup.confirm_password' | translate}}</label>
                                <input type="password" formControlName="confirmPassword" class="form-control" />
                                <div *ngIf="f.confirmPassword.touched && f.confirmPassword.invalid" class="text-danger small mt-1">
                                    <span *ngIf="f.confirmPassword.errors.required">{{'signup.no_confirm_password' | translate}}</span>
                                    <span *ngIf="f.confirmPassword.errors.mustMatch">{{'signup.password_mismatch' | translate}}</span>
                                </div>
                            </div>
                            <div class="d-grid gap-2 d-md-flex justify-content-md-start">
                                <button type="submit" [disabled]="submitted || form.untouched || form.invalid" class="btn btn-primary">
                                    {{'common.change' | translate}}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-sidebar [currentUser]="currentUser"></app-sidebar>
            </div>
        </div>
    </div>
</div>
